import { OrganizationRoles } from "@/shared/utils/constants";

export const getRolesByPermissionLevel = (
  currentUserRole?: string,
  rolesObject = OrganizationRoles,
) => {
  if (!currentUserRole) return [];
  const currentRole = rolesObject.getItemByValue(currentUserRole);

  if (!currentRole || typeof currentRole.priority !== "number") {
    return [];
  }

  const currentPriority = currentRole.priority;

  return rolesObject.asList().filter((roleOption: { value: string }) => {
    const role = rolesObject.getItemByValue(roleOption.value);
    return (
      role &&
      typeof role.priority === "number" &&
      role.priority <= currentPriority
    );
  });
};
